import React, { useEffect, useState } from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelIcon from "@mui/icons-material/Cancel";
import { axios } from "../../utils/axios";
import Modal from "../../components/Modal";
import CheckoutSubscriptionForm from "../../components/stripSubscription.jsx";
import { toast } from "react-toastify";
import { Elements } from "@stripe/react-stripe-js";
import Spinner from "../../components/Spinner/index.jsx";
import { loadStripe } from "@stripe/stripe-js";
const Subscriptions = () => {
  const [plans, setPlans] = useState([]);
  const [subOpen, setSubOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [stripePromise, setStripePromise] = useState(null);
  const [paymentOpen, setPaymentOpen] = useState(false);
  const [clientSecret, setClientSecret] = useState("");
  const [btnloder, setBtnLoader] = useState(false);
  useEffect(() => {
    setStripePromise(loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY));
    getPlans();
  }, []);
  const getPlans = () => {
    axios
      .get(process.env.REACT_APP_BACKEND + "auth/getactivesubscription")
      .then((resp) => {
        setPlans(resp.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const upgradeSubscription = (val) => {
    if (val.sessionId) {
      setSelectedId(val);
      setSubOpen(true);
    } else {
      setSelectedId(val);
      setBtnLoader(true);
      axios
        .post(process.env.REACT_APP_BACKEND + "auth/membershipsubscribtion", {
          planName: val.value,
        })
        .then((resp) => {
          setClientSecret(resp.data.clientSecret);
          setPaymentOpen(true);
          setBtnLoader(false);
        })
        .catch((err) => {
          console.log(err);
          setBtnLoader(false);
          toast.error("Something went wrong");
        });
    }
  };
  const cancelSubscription = () => {
    axios
      .get(
        process.env.REACT_APP_BACKEND +
          `auth/subscriptioncancel?session_id=${selectedId.sessionId}`,
        {
          planName: selectedId.value,
        }
      )
      .then((resp) => {
        setSubOpen(false);
        toast.success(resp?.data?.message);
        setBtnLoader(false);
        getPlans();
      })
      .catch((err) => console.log(err));
  };
  const onPaymentSuccess = () => {
    setPaymentOpen(false);
    getPlans();
    toast.success("Subscribed successfully");
  };
  return (
    <div
      className="  bxShadow px-3 py-4 "
      style={{
        background: "var(--white-color)",
        borderRadius: "12px",
      }}
    >
      <h2>Subscriptions</h2>
      <hr className="my-3" />
      <div
        className="d-flex align-items-center justify-content-center flex-wrap  "
        style={{ gap: 20, background: "var(--white-color)" }}
      >
        {plans.map((mdata) => (
          <div
            key={mdata._id} // Added key here for the outer div
            className="membership-card "
            style={{ maxWidth: "33.33%" }}
          >
            <h4
              className="t-center p-3"
              style={{
                borderTopLeftRadius: "4px",
                borderTopRightRadius: "4px",
                background:
                  mdata?.activePlan === true
                    ? "var(--primary-color)"
                    : mdata.value === "leisure"
                    ? "#FFD35A"
                    : mdata.value === "vip"
                    ? "#EE86A7"
                    : mdata.value === "corporate"
                    ? "#636AE8"
                    : "initial",
              }}
            >
              {mdata?.activePlan === true && "Active"}
            </h4>
            <div
              className="boxShadow"
              style={{
                padding: "10px 25px",
              }}
            >
              <div>
                <h2 className="t-center">{mdata?.planName}</h2>
                <p className="t-center fs-8">{mdata?.dscp}</p>
                <div className="my-3 t-center">
                  {mdata.value === "leisure" ? (
                    <h2>Free</h2>
                  ) : (
                    <h2>
                      ${mdata.price}{" "}
                      <span className="fs-8">/{mdata.duration}</span>
                    </h2>
                  )}
                </div>
                {mdata.perks.map((pdata, index) => (
                  <div className="d-flex align-items-start my-2" key={index}>
                    <p>
                      {pdata.status === false ? (
                        <CancelIcon sx={{ width: "18px", color: "#FF2400" }} />
                      ) : (
                        <CheckCircleOutlineIcon
                          sx={{
                            width: "20px",
                            height: "20px",
                            color: "var(--primary-color)",
                          }}
                        />
                      )}
                    </p>
                    <p className="ms-2 fs-8">{pdata?.description}</p>
                  </div>
                ))}
              </div>
              {mdata.value === "leisure" ? (
                <></>
              ) : (
                <button
                  className={`btn-outlined w100 btn-${mdata?.id} ${
                    mdata?.activePlan === true
                      ? "hover-style-active"
                      : mdata.value === "leisure"
                      ? "hover-style-1"
                      : mdata.value === "vip"
                      ? "hover-style-2"
                      : mdata.value === "corporate"
                      ? "hover-style-3"
                      : ""
                  }`}
                  onClick={() => upgradeSubscription(mdata)}
                >
                  {mdata?.activePlan === true ? (
                    "Cancel"
                  ) : (
                    <div className="d-flex align-items-center justify-content-center">
                      {" "}
                      Upgrade{" "}
                      {btnloder && selectedId.value === mdata.value && (
                        <Spinner />
                      )}
                    </div>
                  )}
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
      <Modal
        open={subOpen}
        onClose={() => {
          setSubOpen(false);
          setSelectedId(null);
        }}
        title="Cancel Subscription"
        size="sm"
      >
        <p className="mt-4">
          Are you sure you want to cancel the subscription?
        </p>
        <div
          className="mt-4 d-flex alifn-items-center justify-content-end"
          style={{ gap: 20 }}
        >
          <button
            className="btn-outlined"
            onClick={() => {
              setSubOpen(false);
              setSelectedId(null);
            }}
          >
            Cancel
          </button>
          <button className="btn-contained" onClick={cancelSubscription}>
            Confirm
          </button>
        </div>
      </Modal>
      <Modal
        open={paymentOpen}
        onClose={() => setPaymentOpen(false)}
        title="Subscription Payment"
        size="sm"
      >
        <div className="row p-2">
          <div
            className="col-md-12 bxShadow py-3  "
            style={{ borderRadius: "8px" }}
          >
            <Elements stripe={stripePromise} options={{ clientSecret }}>
              <CheckoutSubscriptionForm
                planName={selectedId}
                onSuccess={onPaymentSuccess}
              />
            </Elements>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Subscriptions;
